module['exports'] = [
  'پانڈا',
  'بھالو',
  'امریکی کالا بھالو',
  'ایشیایٰ کالا بھالو',
  'بھورا بھالو',
];
